module.exports={
  "homePage_onboardingMessage": {
    "id": "homePage_onboardingMessage",
    "eventName": "completar_KYB",
    "eventProduct": "tela inicial",
    "eventCategory": "tela inicial",
    "eventAction": "Botao de redirecionamento cartoes | Tela inicial",
    "eventValue": 0
  },
  "homePage_fundsInMessage": {
    "id": "homePage_fundsInMessage",
    "eventName": "realizar_deposito",
    "eventProduct": "tela inicial",
    "eventCategory": "tela inicial",
    "eventAction": "Botao de redirecionamento cartoes | Tela inicial",
    "eventValue": 0
  }
}
